var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sun",
    transform: "translate(-863.264 -599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_373",
    "data-name": "Ellipse 373",
    transform: "translate(863.264 599)",
    fill: "none",
    stroke: "#51aabc",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 51.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SUN-2",
    "data-name": "SUN",
    transform: "translate(869.9 604.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sun_5_",
    "data-name": "sun (5)",
    transform: "translate(9.435 10.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8563",
    "data-name": "Trac\\xE9 8563",
    d: "M71.684,39.313l-5.063,5.206L68.4,51.554a4.14,4.14,0,0,1-2.891,5l-6.988,1.968-1.968,6.988a4.14,4.14,0,0,1-5,2.891L44.52,66.62l-5.206,5.063a4.141,4.141,0,0,1-5.773,0L28.335,66.62,21.3,68.4a4.14,4.14,0,0,1-5-2.891l-1.968-6.988L7.343,56.556a4.14,4.14,0,0,1-2.891-5l1.783-7.034L1.172,39.313a4.14,4.14,0,0,1,0-5.773l5.063-5.206L4.452,21.3a4.14,4.14,0,0,1,2.891-5l6.988-1.968L16.3,7.342a4.14,4.14,0,0,1,5-2.891l7.034,1.783,5.206-5.063a4.141,4.141,0,0,1,5.773,0L44.52,6.234l7.035-1.783a4.14,4.14,0,0,1,5,2.891l1.968,6.988L65.513,16.3a4.14,4.14,0,0,1,2.891,5l-1.783,7.034,5.063,5.206A4.141,4.141,0,0,1,71.684,39.313Zm0,0",
    transform: "translate(0 0.001)",
    fill: "#ffde55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8564",
    "data-name": "Trac\\xE9 8564",
    d: "M32.308,76.987c-12.949-15.76-9.733-37.969-7.642-45.619L21.3,30.515a4.141,4.141,0,0,0-5,2.891l-1.968,6.988L7.343,42.361a4.14,4.14,0,0,0-2.891,5L6.235,54.4,1.172,59.6a4.14,4.14,0,0,0,0,5.773l5.063,5.206L4.452,77.618a4.14,4.14,0,0,0,2.891,5l6.988,1.968L16.3,91.576a4.14,4.14,0,0,0,5,2.891l7.034-1.783,5.207,5.063a4.14,4.14,0,0,0,5.772,0l3.157-3.07A60.491,60.491,0,0,0,32.308,76.987Zm0,0",
    transform: "translate(0 -26.063)",
    fill: "#ffc757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8565",
    "data-name": "Trac\\xE9 8565",
    d: "M130.236,105.222a25.015,25.015,0,1,1-25.015-25.015A25.014,25.014,0,0,1,130.236,105.222Zm0,0",
    transform: "translate(-68.794 -68.794)",
    fill: "#ffeb99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8566",
    "data-name": "Trac\\xE9 8566",
    d: "M101.1,143.392c-9.128-11.109-10.224-25.423-9.343-35.583a25.017,25.017,0,0,0,13.462,46.1,25.373,25.373,0,0,0,2.788-.153A61.6,61.6,0,0,0,101.1,143.392Zm0,0",
    transform: "translate(-68.794 -92.468)",
    fill: "#ffe36c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.613c4d2f.svg";
export { ForwardRef as ReactComponent };